import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { graphData, kosten } from '../content/content.model';

am4core.useTheme(am4themes_animated);
am4core.options.commercialLicense = true;

@Component(
    {
        name: 'areachart',
    }
)
export default class AreaChartComponent extends Vue {
    @Prop({ required: true })
    chartData!: graphData<kosten>;

    name: string = "";
    id: string = "";
    chart: any;

    mounted() {
        this.id = "chartdiv_area";
    }

    updated() {
        this.name = this.chartData.name!;
        this.generateChart();
    }

    beforeDestroy() {
        if (this.chart)
            this.chart.dispose();
    }

    @Watch('chartData')
    onDataUpdate() {
        this.$forceUpdate();
    }

    generateChart() {
        if (this.chart)
            this.chart.dispose();

        // Create chart
        this.chart = am4core.create(this.id, am4charts.XYChart);
        //"lineColor": chart.colors.next()
        this.chart.data = this.chartData.data;

        var categoryAxis = this.chart.xAxes.push(new am4charts.DateAxis());
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.ticks.template.disabled = true;
        categoryAxis.renderer.line.opacity = 0;
        categoryAxis.renderer.grid.template.disabled = true;
        categoryAxis.renderer.minGridDistance = 40;
        // categoryAxis.dataFields.category = "time";
        categoryAxis.startLocation = 0.4;
        categoryAxis.endLocation = 0.6;
        categoryAxis.baseInterval = {
            timeUnit: "second",
            count: 1
        };


        var valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.tooltip.disabled = true;
        valueAxis.renderer.line.opacity = 0;
        valueAxis.renderer.ticks.template.disabled = true;
        valueAxis.min = 0;

        var lineSeries = this.chart.series.push(new am4charts.LineSeries());
        lineSeries.dataFields.dateX = "time";
        lineSeries.dataFields.valueY = "value";
        lineSeries.yAxis = valueAxis;
        lineSeries.xAxis = categoryAxis;
        lineSeries.tooltipText = "{description}";
        lineSeries.fillOpacity = 0.5;
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.stroke = "lineColor";
        lineSeries.propertyFields.fill = "lineColor";

        // var bullet = lineSeries.bullets.push(new am4charts.CircleBullet());
        // bullet.circle.radius = 6;
        // bullet.circle.fill = am4core.color("#fff");
        // bullet.circle.strokeWidth = 3;

        this.chart.cursor = new am4charts.XYCursor();
        this.chart.cursor.behavior = "panX";
        this.chart.cursor.lineX.opacity = 0;
        this.chart.cursor.lineY.opacity = 0;
    }
}